// extracted by mini-css-extract-plugin
export default {"root":"VMStopTable_root__ecO4a"};